import {initElements} from "../../define/shared";

export default function initSubMenu() {
    initElements(".sub-menu.ct-side-block", block => {
        const menuItems = block.querySelectorAll(".has--child-menu");

        menuItems.forEach(item => {
            const plus = item.querySelector(".icon-plus");
            plus.addEventListener("click", () => {
                item.parentNode.classList.toggle("is--open");
            });
        });
    });
}
